export default __webpack_public_path__ + "static/media/ZZC_7873.68bdf32d.jpg";